import clsx from "clsx";
import React from "react";
import { chaseHeadingData } from "./chaseListComponents/chaseListData";
import SkeltonTableRow from "./skelton/SkeltonTableRow";
import NoItem from "./NoItem";

interface ITableWrapper {
  children: React.ReactNode;
  headingData: typeof chaseHeadingData;
  additionalClasses?: string;
  isLoading?: boolean;
  totalCount?: number;
}

/**
 * Column headers are small, letter-spaced and muted so they label the data without
 * competing with it, and each carries its column's alignment so numeric columns line
 * up with the figures beneath them.
 */
const TableWrapper: React.FC<ITableWrapper> = ({
  children,
  headingData,
  additionalClasses,
  isLoading,
  totalCount,
}) => {
  return (
    <>
      <div className="max-lg:overflow-x-auto max-lg:-mx-1 max-lg:px-1">
      <table
        className={clsx(
          "table-auto h-max w-full text-left max-lg:min-w-[960px]",
          additionalClasses
        )}
      >
        <thead>
          <tr>
            {headingData.map((data, index) => (
              <th
                key={index}
                className={clsx(
                  "bg-surface uppercase text-light-gray font-semibold text-[10px] tracking-[0.08em] py-3 border-b border-edge first:pl-1",
                  (data as any).align === "right" && "text-right",
                  (data as any).align === "center" && "text-center"
                )}
              >
                {data.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{isLoading ? <SkeltonTableRow /> : children}</tbody>
      </table>
      </div>
      {totalCount === 0 && !isLoading && <NoItem />}
    </>
  );
};

export default TableWrapper;
